import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'literMask'
})
export class LiterMaskPipe implements PipeTransform {

    transform(value: any, args?: any): any {
        if (value) {
            value = value.toString();
            value = value.replace('.', ",");

            let isNegative: boolean = (value < 0) ? true : false;

            if (isNegative) {
                value = value * (-1);
                value = value.toString();
            }

            let commonIndex: number = value.lastIndexOf(","),
                beforeCommon: string = value,
                afterCommon: string = '';

            if (commonIndex !== -1) {
                beforeCommon = value.substr(0, commonIndex);
                afterCommon = value.substr(commonIndex, value.length);
            }

            let beforeCommonSplit: string[] = beforeCommon.split('').reverse();
            let x  = 0, lenX = beforeCommonSplit.length,
                countPoint: number = 3;

            for (x, lenX; x < lenX; x++) {
                if (x === countPoint) {
                    beforeCommonSplit[x] = beforeCommonSplit[x].concat(".");
                    countPoint += 3;
                }
            }

            let newNumber: string = beforeCommonSplit.reverse().toString();
            newNumber = newNumber.replace(/,/g, '');

            if (afterCommon.length > 3) {
                afterCommon = afterCommon.substr(0, 4)
            }
            newNumber = newNumber.concat(afterCommon);

            if (isNegative) {
                newNumber = "-".concat(newNumber);
            }

            return newNumber;
        } else {
            return 0;
        }
    }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/shared/pipes/liter-mask.pipe.ts
 **/